const getURLparams = url => {
  const parameters = new URLSearchParams(url);

  let obj = {};

  for (const p of parameters) {
    obj = {
      ...obj,
      [p[0]]: p[1]
    };
  }

  return obj;
};

export default getURLparams;
